import React from 'react';
import { object } from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import SafePureComponent from '../shared/SafePureComponent';
import { DISCLAIMERS } from './constants';

import './style.scss';

const Disclaimer = (props, { general }) => {
    const { subCategoryId } = general;

    if (!Object.keys(DISCLAIMERS).includes(String(subCategoryId))) {
        return null;
    }

    const { title, description } = DISCLAIMERS[subCategoryId];

    return (
        <div className="disclaimer">
            <header>
                <h6><I18n k={title}/></h6>
            </header>

            <p><I18n k={description}/></p>
        </div>
    );
};

Disclaimer.contextTypes = {
    general: object
};

export { Disclaimer };
export default SafePureComponent(Disclaimer);
